// import ShareImg from '../assets/img/common/share.png'
import {
  getDeviceInfo,
  gethttpurl
  // QueryToJSON,
  // JsonToParams
} from './tools'
import { WxShare } from './wxShare'

// 设置分享
export function SetLeChengShare() {
  // const htmlPath = location.origin + location.pathname
  // const imgUrl = htmlPath.replace('index.html', ShareImg)
  const PlatInfo = getDeviceInfo()

  // const imgUrl = process.env.VUE_APP_BUILD_TARGET === 'prod' ? ShareImg : htmlPath.replace('index.html', ShareImg)
  const imgUrl = 'https://static-cdn.yuanxinbaoxian.com/prod/images/yueyangbao/wxshareImg.png'
  // const PlatInfo = getDeviceInfo()

  if (PlatInfo.env === 'wechat') {
    // alert(gethttpurl('baosicode'))
    // const Query = QueryToJSON()
    // const searchStr = JsonToParams(Query)
    // const link =
    //   location.origin + location.pathname + searchStr + '#/area-insu-buy-detail'
    let jhb = gethttpurl('fromSourceCode') ? `?fromSourceCode=${gethttpurl('fromSourceCode')}` : '?fromSourceCode=yxhb00000001' 
    let productCode = gethttpurl('productCode') ? `&productCode=${gethttpurl('productCode')}` : ''
    let baosicode = gethttpurl('baosicode') ? `&baosicode=${gethttpurl('baosicode')}` : `&baosicode=${process.env.VUE_APP_BAOSICODE}`
    const link = location.origin + location.pathname + jhb + productCode +baosicode+ '#/area-insu-buy-detail'
    WxShare({
      title: '政府指导！岳阳专属！138元保全年，最高400万医疗保障！',
      link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      desc: '保障范围广，涵盖医保住院、门诊特殊疾病以及89种特定药品费用。'
    })
  }
}

// 企业预约页面分享
export function SetCompanyAppointmentShare() {
  // const htmlPath = location.origin + location.pathname
  // const imgUrl = process.env.VUE_APP_BUILD_TARGET === 'prod' ? ShareImg : htmlPath.replace('index.html', ShareImg)
  const imgUrl = 'https://static-cdn.yuanxinbaoxian.com/prod/images/yueyangbao/wxshareImg.png'
  const PlatInfo = getDeviceInfo()

  if (PlatInfo.env === 'wechat') {
    // const Query = QueryToJSON()
    // const searchStr = JsonToParams(Query)
    // const link =
    //   location.origin + location.pathname + searchStr + '#/company-appointment'
    let jhb = gethttpurl('fromSourceCode') ? `?fromSourceCode=${gethttpurl('fromSourceCode')}` : '?fromSourceCode=yxhb00000001'
    let productCode = gethttpurl('productCode') ? `&productCode=${gethttpurl('productCode')}` : ''
    let baosicode = gethttpurl('baosicode') ? `&baosicode=${gethttpurl('baosicode')}` : `&baosicode=${process.env.VUE_APP_BAOSICODE}`
    const link = location.origin + location.pathname + jhb + productCode+baosicode + '#/company-appointment'
    WxShare({
      title: '政府指导！岳阳专属！138元保全年，最高400万医疗保障！',
      link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      desc: '保障范围广，涵盖医保住院、门诊特殊疾病以及89种特定药品费用。'
    })
  }
}